/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { getRoomFromID } from "../utils/RoomUtils";
import Notification from "../components/Notification";
import FirstUserExperience from "../widgets/FirstUserExperience";

const Room = React.memo(() => {
    const currentRoomID = useSelector((state) => state.room.history[0].ID);
    const isLoggedIn = useSelector((state) => state.user.data.socketId);
    const notification = useSelector((state) => state.private.notification);
    const device = useSelector((state) => state.private.device);

    if (!isLoggedIn && !window.location.pathname.includes('login'))
        window.location.replace('/login/')

    const CurrentRoom = getRoomFromID(currentRoomID);

    return <>
        {notification && <Notification />}
        {!device.inVRMode && !device.cooperative ? <FirstUserExperience /> : null}
        <CurrentRoom />
    </>
});

export default Room;
